import { PlatformUtil } from './platform-utils.js';
import { KeyCodeFireFox, KeyCode, MOUSE_EVENT_TIMES, WheelCode, KeyAssist } from './key-code.js';

/**
 * 键盘工具
 * @public
 */
class KeyHelper {
    /**
     * 获取keyCode，对FireFox进行兼容处理
     * @param keyEvent - 键盘事件
     */
    static getKeyCode(keyEvent) {
        let { keyCode } = keyEvent;
        if (PlatformUtil.isFireFox()) {
            if (keyCode === KeyCodeFireFox.EQUAL) {
                keyCode = KeyCode.EQUAL;
            }
            else if (keyCode === KeyCodeFireFox.MINUS) {
                keyCode = KeyCode.MINUS;
            }
        }
        return keyCode;
    }
    static getMouseCode(mouseEvent) {
        return mouseEvent.buttons * MOUSE_EVENT_TIMES;
    }
    static getWheelCode(wheelEvent) {
        let wheelCode = 0;
        if (wheelEvent.deltaY > 0) {
            wheelCode = WheelCode.WHEEL_CLOCKWISE;
        }
        else if (wheelEvent.deltaY < 0) {
            wheelCode = WheelCode.WHEEL_ANTICLOCKWISE;
        }
        return wheelCode;
    }
    /**
     * 获取ctrl, shift, alt, meta状态，区分mac/win
     * @param keyEvent - 键盘事件
     */
    static getAssistKey(keyEvent) {
        let assitKey = 0;
        if (PlatformUtil.isMac() || PlatformUtil.isIPad()) {
            assitKey += keyEvent.altKey ? KeyAssist.ALT : 0;
            assitKey += keyEvent.shiftKey ? KeyAssist.SHIFT : 0;
            assitKey += keyEvent.ctrlKey ? KeyAssist.CTRL_MAC : 0;
            assitKey += keyEvent.metaKey ? KeyAssist.COMMAND : 0;
        }
        else {
            assitKey += keyEvent.altKey ? KeyAssist.ALT : 0;
            assitKey += keyEvent.shiftKey ? KeyAssist.SHIFT : 0;
            assitKey += keyEvent.ctrlKey ? KeyAssist.CTRL_WIN : 0;
            assitKey += keyEvent.metaKey ? KeyAssist.WIN : 0;
        }
        return assitKey;
    }
}

export { KeyHelper };
//# sourceMappingURL=key-helper.js.map
